import { render, staticRenderFns } from "./InputInboxDraft.vue?vue&type=template&id=4f1e0730&"
import script from "./InputInboxDraft.vue?vue&type=script&lang=js&"
export * from "./InputInboxDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports